/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const DoubleChevron: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.51167 9.43066C9.79254 9.18992 10.2074 9.18992 10.4882 9.43066L17.4882 15.4307L17.5439 15.4834C17.8059 15.7587 17.822 16.1935 17.5693 16.4883C17.2997 16.8026 16.8261 16.8388 16.5117 16.5693L9.99995 10.9873L3.48823 16.5693C3.17382 16.8388 2.70021 16.8025 2.43061 16.4883C2.1611 16.1739 2.19735 15.7003 2.51167 15.4307L9.51167 9.43066ZM9.51167 3.43066C9.79254 3.18992 10.2074 3.18992 10.4882 3.43066L17.4882 9.43066L17.5439 9.4834C17.8059 9.75869 17.822 10.1935 17.5693 10.4883C17.2997 10.8026 16.8261 10.8388 16.5117 10.5693L9.99995 4.9873L3.48823 10.5693C3.17382 10.8388 2.70021 10.8025 2.43061 10.4883C2.1611 10.1739 2.19735 9.70026 2.51167 9.43066L9.51167 3.43066Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default DoubleChevron;
